import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PartnerLocationRequestItem } from './partnerReducer';

export interface LocationRequestState {
  items: PartnerLocationRequestItem[];
  total: number;
  limit: number;
  offset: number;
  loading: boolean;
  error: string | null;
  selectedRequest: PartnerLocationRequestItem | null;
}

const initialState: LocationRequestState = {
  items: [],
  total: 0,
  limit: 50,
  offset: 0,
  loading: false,
  error: null,
  selectedRequest: null,
};

const locationRequestSlice = createSlice({
  name: 'locationRequests',
  initialState,
  reducers: {
    setLocationRequestLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setLocationRequestError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setLocationRequestPage: (
      state,
      action: PayloadAction<{
        items: PartnerLocationRequestItem[];
        total: number;
        limit: number;
        offset: number;
      }>
    ) => {
      const { items, total, limit, offset } = action.payload;
      state.items = items;
      state.total = total;
      state.limit = limit;
      state.offset = offset;
    },
    updateLocationRequestInList: (
      state,
      action: PayloadAction<PartnerLocationRequestItem>
    ) => {
      const idx = state.items.findIndex((r) => r.id === action.payload.id);
      if (idx !== -1) {
        state.items[idx] = action.payload;
      }
      if (state.selectedRequest?.id === action.payload.id) {
        state.selectedRequest = action.payload;
      }
    },
    setSelectedLocationRequest: (
      state,
      action: PayloadAction<PartnerLocationRequestItem | null>
    ) => {
      state.selectedRequest = action.payload;
    },
  },
});

export const {
  setLocationRequestLoading,
  setLocationRequestError,
  setLocationRequestPage,
  updateLocationRequestInList,
  setSelectedLocationRequest,
} = locationRequestSlice.actions;

export default locationRequestSlice.reducer;
